import React from 'react'
import { Link } from 'react-router-dom'

const CandidateModal = ({setShowLogoutModal}) => {
  return (
    <div className="absolute top-16 right-20 bg-white rounded-lg shadow border z-10 whitespace-nowrap overflow-hidden">
    <Link to={`/mira-lenta/profile`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      Mon profil
      </div>
    </Link>
    <hr />
    <Link to={`/mira-lenta/cv`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      Mon CV
      </div>
    </Link>
    <Link to={`/mira-lenta/candidature`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      Candidature
      </div>
    </Link>
    <Link to={`/mira-lenta/enregistrement`}>
      <div className="text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center">
      Mes enregistrements
      </div>
    </Link>
    <hr/>
    <button
    onClick={()=>setShowLogoutModal(true)}
      className="w-full text-sm cursor-pointer hover:bg-gray-100 py-2 px-6 text-slate-700 flex gap-2 items-center"
    >
      Se déconnecter
    </button>
  </div>
  )
}

export default CandidateModal